import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Image from '../Image';
import Button from '../Button';
import Icon from '../Icon';

import './styles.less';

const renderTitle = (title, titleElement, iconName, textBgColor) => {
    return (
        <div className="p-hero__title-container">
            {titleElement || (
                <div style={{ backgroundColor: textBgColor }} className="p-scrim p-hero__title">
                    {iconName ? <Icon name={iconName} size="md" /> : title}
                </div>
            )}
        </div>
    );
};

const renderBlurb = (blurb, textBgColor) => {
    return (
        <div className="p-hero__blurb-container">
            <p style={{ backgroundColor: textBgColor }} className="p-scrim p-hero__blurb">
                {blurb}
            </p>
        </div>
    );
};

const renderButton = (button, index) => {
    return <Button className="p-hero__button" {...button} key={button.contentId ? button.contentId : index} />;
};

const Hero = (props) => {
    return (
        <div className="p-hero" data-content-id={props.contentId}>
            <Image {...props.image} aspectRatio="4:1" />
            <div className="p-hero__body">
                <div
                    style={{ color: props.color }}
                    className={classNames({
                        'p-hero__body-text': true,
                        [`p-hero__body-text--vertical-${props.verticalTextPosition}`]: true,
                        [`p-hero__body-text--horizontal-${props.horizontalTextPosition}`]: true
                    })}
                >
                    {props.title || props.titleElement
                        ? renderTitle(props.title, props.titleElement, props.iconName, props.textBgColor)
                        : null}
                    {props.blurb ? renderBlurb(props.blurb, props.textBgColor) : null}
                    {props.buttons ? (
                        <div className="p-hero__buttons-container">{props.buttons.map(renderButton)}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

Hero.propTypes = {
    title: PropTypes.string,
    blurb: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape(Button.propTypes)),
    contentId: PropTypes.string,
    verticalTextPosition: PropTypes.oneOf(['Bottom', 'bottom', 'Center', 'center', 'Top', 'top']),
    horizontalTextPosition: PropTypes.oneOf(['Left', 'left', 'Center', 'center', 'Right', 'right']),
    image: PropTypes.shape(Image.propTypes).isRequired,
    textBgColor: PropTypes.string,
    color: PropTypes.string,
    titleElement: PropTypes.element,
    iconName: PropTypes.string
};

Hero.defaultProps = {
    textBgColor: 'rgba(51,51,51,.85)', //@mlb-grey-800
    color: '#FFFFFF'
};

export default Hero;
